<!-- 律师之家 -->
<template>
  <div class="lawyerHome">
    <div class="lawyer-home">
      <div class="lawyer-home-top">
        <img class="lawyer-home-top-img1" src="../assets/images/home.png" alt="" />
        <img class="lawyer-home-top-img2" src="../assets/images/lawyer.png" alt="" />
        <span class="lawyer-home-top-text">快捷入口，一键进入</span>
      </div>
      <div class="lawyer-home-content">
        <div class="lawyer-home-item" @click="toRightProtection('lawyerHome')">
          <div class="lawyer-home-item-icon">
            <i class="iconfont icon-zglsweiquanguanli"></i>
          </div>
          <div class="lawyer-home-item-text">
            全国律协<br />维护律师执业权利中心
          </div>
        </div>

        <div class="lawyer-home-item" @click="toComplainView('lawyerHome')">
          <div class="lawyer-home-item-icon">
            <i class="iconfont icon-zglstousujianyi"></i>
          </div>
          <div class="lawyer-home-item-text">
            全国律协<br />投诉受理查处中心
          </div>
        </div>

        <div class="lawyer-home-item">
          <a href="https://oa.acla.org.cn/login.jsp">
            <div class="lawyer-home-item-icon">
              <i class="iconfont icon-zglsgongzuotai-"></i>
            </div>
            <div class="lawyer-home-item-text">
              全国律师<br />综合管理信息系统
            </div>
          </a>
        </div>

        <div class="lawyer-home-item">
          <a href="https://credit.acla.org.cn/">
            <div class="lawyer-home-item-icon">
              <i class="iconfont icon-zglsxitong"></i>
            </div>
            <div class="lawyer-home-item-text">
              全国律师<br />诚信信息公示平台
            </div>
          </a>
        </div>

        <div class="lawyer-home-item">
          <a href="https://oralreview.acla.org.cn/#/qr-login">
            <div class="lawyer-home-item-icon">
              <i class="iconfont icon-zglskoushenshenqing"></i>
            </div>
            <div class="lawyer-home-item-text">
              律师担任专利权无效宣告<br />
              案件口头审理代理人<br />
              申请平台
            </div>
          </a>
        </div>

        <div class="lawyer-home-item">
          <a href="https://oralreview.acla.org.cn/#/publicity">
            <div class="lawyer-home-item-icon">
              <i class="iconfont icon-zglskoushenchaxun"></i>
            </div>
            <div class="lawyer-home-item-text">

              推荐律师担任专利权<br />
              无效宣告案件口头审理<br />
              代理人名单查询入口
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="menu">
      <div class="menu-item" @click="changeMenu()">
        <img :src="menuImgLeft" class="menu-img" alt="" />
        <div class="menu-text">首页</div>
      </div>
      <div class="menu-line"></div>
      <div class="menu-item">
        <img :src="menuImgRight" class="menu-img" alt="" />
        <div class="menu-text">律师之家</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuImgLeft: require("../assets/images/index1-menu.png"),
      menuImgRight: require("../assets/images/lawyer1-menu.png"),
    };
  },
  methods: {
    changeMenu() {
      this.$router.push({
        name: "home",
      });
    },
    toRightProtection(from) {
      this.$router.push({
        name: "rightProtection",
        params: { from: from, list: "" },
      });
    },
    toComplainView(from) {
      this.$router.push({
        name: "complainView",
        params: { from: from, list: "" },
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.lawyerHome {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f7f8fa;

  .lawyer-home {
    margin-bottom: 1rem;
    width: 100%;
    height: calc(100% - 4.5rem);
    background: #ffffff;
    border-radius: 0.75rem 0.75rem 0rem 0rem;

    .lawyer-home-top {
      position: relative;
      width: 100%;
      height: 5.13rem;
      padding: 3rem 0 0 1rem;
      box-sizing: border-box;
      background: linear-gradient(rgba(5, 90, 215, 0.16) 0%,
          rgba(255, 255, 255, 0) 100%);
      box-shadow: 0rem -0.25rem 0.38rem 0rem rgba(192, 192, 192, 0.15);

      &-img1 {
        position: absolute;
        left: 1rem;
        width: 1.13rem;
        height: 1rem;
      }

      &-img2 {
        position: absolute;
        left: 2.63rem;
        width: 4.88rem;
        height: 1.81rem;
      }

      &-text {
        position: absolute;
        left: 8.25rem;
        font-weight: 500;
        font-size: 0.75rem;
        color: rgba(0, 0, 0, 0.65);
        line-height: 1.06rem;
        text-align: left;
      }
    }

    .lawyer-home-content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width:  100%;
      padding: 0.75rem 1rem 1rem 1rem;
      box-sizing: border-box;

      .lawyer-home-item {
        margin-bottom: 1rem;
        width:  calc(50% - 0.5rem);
        
        // height: 7.25rem;
        padding-top: 1.83rem;
        box-sizing: border-box;
        background: #ffffff;
        box-shadow: 0rem 0rem 0.75rem 0rem rgba(0, 0, 0, 0.05);
        border-radius: 0.5rem;

        .lawyer-home-item-icon {
          margin: 0 0 0.63rem 0;
          text-align: center;

          .iconfont {
            font-size: 1.25rem;
          }

          .icon-zglsweiquanguanli {
            color: #fc7a43;
          }

          .icon-zglstousujianyi {
            color: #8770fc;
          }

          .icon-zglsgongzuotai- {
            color: #fdab4d;
          }

          .icon-zglsxitong {
            color: #8770fc;
          }

          .icon-zglsguifanwendang {
            color: #fc7a43;
          }

          .icon-zglszhiyin {
            color: #8770fc;
          }
          .icon-zglskoushenshenqing {
            color: #fc7a43;
          }
          .icon-zglskoushenchaxun {
            color: #FDAB4D;
          }
          .icon-zglsguifanwendang {
            color: #fc7a43;
          }
          .icon-zglszhiyin {
            color: #8770fc;
          }
        }

        .lawyer-home-item-text {
          margin: 0 auto;
          padding-bottom: 0.88rem;
          font-weight: 500;
          font-size: 0.75rem;
          color: rgba(0, 0, 0, 0.85);
          line-height: 1.06rem;
          text-align: center;
        }
      }
    }
  }

  .menu {
    display: flex;
    width: 100%;
    height: 3.5rem;
    background: #ffffff;
    text-align: center;

    .menu-item {
      flex: 1;

      .menu-img {
        width: 1.75rem;
        height: 1.75rem;
      }

      .menu-text {
        font-weight: 500;
        font-size: 0.69rem;
        color: rgba(0, 0, 0, 0.85);
        line-height: 0.88rem;
        text-align: center;
        font-style: normal;
      }
    }

    .menu-line {
      margin-top: 0.75rem;
      width: 0.06rem;
      height: 2rem;
      background: #e4e4e4;
    }
  }
}
</style>